export * from './components';
export const backgroundToTokens = (bg)=>({
        bg: bg && bg !== 'transparent' ? `${bg === 'pink' ? 'fill.new' : `background.${bg}`}` : 'transparent',
        color: [
            'white',
            'pink',
            'light'
        ].includes(bg) ? 'text.primary' : 'text.inverse'
    });

//# sourceMappingURL=index.js.map